export default [
  {
    id: 'e7745786-5e5f-4402-b538-a629ded87e5c',
    path: 'pipe-extraction',
    name: 'pipeExtraction',
    meta: { title: '管线抽离' },
    component: () => {
      return import('../views/modelBussiness/index')
    },
  },
  {
    id: 'd4f5fe34-bbed-4318-9dc0-c609bcaee38a',
    path: 'pipe-flow-analysis',
    name: 'pipeFlowAnalysis',
    meta: { title: '流向分析' },
    component: () => {
      return import('../views/modelBussiness/index')
    },
  },
]
